import script from "./OrderCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderCreate.vue?vue&type=script&setup=true&lang=ts"

import "./OrderCreate.vue?vue&type=style&index=0&id=dd34953a&lang=css"

const __exports__ = script;

export default __exports__